import React from "react";
import { PropTypes } from 'prop-types';
import { InputField } from "../../../../../CommonComponents/commonStyles";

export default function InputComponent(props) {
  return (
    <InputField
      aria-label={props.ariaLabel}
      width={false}
      name={props.name}
      maxLength={props.maxLength}
      onBlur={props.onBlur}
      onChange={props.onChange}
      value={props.value ? props.value : null}
      placeholder={props.placeholder}
      disabled={props.disabled ? props.disabled : false}
      autoComplete='off'
      id={props.id}
      className={props.className}
    />
  );
}

InputComponent.propTypes = {
  id: PropTypes.string,
  maxLength: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.any,
}